import "./../css/style.css"
import {ILazyLoadInstance} from "vanilla-lazyload"
import {lazyLoading} from "./lazyload/lazyload-init"

declare global {
  interface Window {
    lazyloading?: ILazyLoadInstance
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: Record<string, any>[]
  }
}
window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadFancybox() {
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("./fancybox/fancybox")
  }
}
async function loadMain() {
  await import("./main")
  loadFancybox()
}
loadMain()

async function loadFormValidation() {
  if (document.querySelectorAll('[data-validate="jquery"]').length) {
    await import("./form-validation")
  }
}
loadFormValidation()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file").length) {
    await import("../components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadDateInput() {
  if (document.querySelectorAll(".f-date").length) {
    await import("../components/fields/date-field/date-field")
  }
}
loadDateInput()

async function loadPasswordField() {
  if (document.querySelectorAll(".f-text.--password").length) {
    await import("../components/fields/text-field/text-field--password")
  }
}
loadPasswordField()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("./slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("../components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./swiper/swiper")
  }
}
loadSwiper()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("./../components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadOverlayScrollbars() {
  if (document.querySelectorAll(".u-scrollbars").length) {
    await import("./overlayscrollbars/overlayscrollbars")
  }
}
loadOverlayScrollbars()

async function loadTippy() {
  if (document.querySelectorAll(".i-tooltip").length) {
    await import("./../components/items/tooltip-item/tooltip-item")
  }
}
loadTippy()

async function loadTabsGroup() {
  if (document.querySelectorAll(".g-tabs").length) {
    await import("./../components/groups/tabs-group/tabs-group")
  }
}
loadTabsGroup()

async function loadReviews() {
  if (document.querySelectorAll(".pd-reviews").length) {
    await import("./../components/product-detail/reviews/reviews")
  }
}
loadReviews()

async function loadProductAction() {
  if (document.querySelectorAll(".pd-content").length) {
    await import("./add-to-cart-handle/add-to-cart-handle")
  }
}
loadProductAction()

async function loadStoresMap() {
  if (document.getElementById("map") !== null) {
    await import("./stores-map")
  }
}
loadStoresMap()

async function loadOrdering() {
  if (document.querySelectorAll(".i-ordering").length) {
    await import("./../components/items/ordering-item/ordering-item")
  }
}
loadOrdering()

async function loadContactFormItem() {
  if (document.querySelectorAll(".i-contact-form").length) {
    await import("./../components/items/contact-form-item/contact-form-item")
  }
}
loadContactFormItem()

async function loadProductsHandle() {
  if (document.querySelectorAll(".s-products").length) {
    await import("./products-handle/products-handle")
  }
}
loadSearchHandle()

async function loadSearchHandle() {
  if (document.querySelectorAll(".f-search").length) {
    await import("./search-handle/search-handle")
  }
}
loadProductsHandle()

async function loadShippingAndPayment() {
  if (document.querySelectorAll(".s-shipping-payment").length) {
    await import("../components/sections/shipping-payment-section/shipping-payment-section")
  }
}
loadShippingAndPayment()

async function loadAnchorScroll() {
  await import("./anchor-scroll/anchor-scroll")
}
loadAnchorScroll()

async function loadDatalayerPush() {
  if (document.querySelectorAll("[data-click-event-push]").length) {
    await import("./datalayer-push/datalayer-push")
  }
}
loadDatalayerPush()

async function loadFedcmLogin() {
  if (document.querySelectorAll(".c-login").length) {
    await import("./fedcm-login/fedcm-login")
  }
}
loadFedcmLogin()

async function loadCartEmailCheck() {
    if (document.querySelectorAll(".--js-verify-registered-email").length) {
        await import("./cart-email-check/cart-email-check")
    }
}
loadCartEmailCheck()
